const allowedEnvs = ['QA', 'Production'];

if (allowedEnvs.includes(process.env.REACT_APP_ENV) && window.NREUM && window.NREUM.info) {
  window.NREUM.info = {
    accountID: process.env.REACT_APP_NEWRELIC_ACCOUNT_ID,
    trustKey: process.env.REACT_APP_NEWRELIC_TRUST_KEY,
    agentID: process.env.REACT_APP_NEWRELIC_AGENT_ID,
    licenseKey: process.env.REACT_APP_NEWRELIC_LICENCE_KEY,
    applicationID: process.env.REACT_APP_NEWRELIC_APP_ID,
  };
}
